import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import Fragment from 'vue-fragment'
import { BModal } from 'bootstrap-vue'
import plankton, { alertModalMixin } from 'plankton'
import { toKilometers, toDate } from './vue-filters'

export function registerGlobalComponents() {
  Vue.use(plankton)
  Vue.component('b-modal', BModal)
}

export function registerPlugins() {
  Vue.use(VueCompositionApi)
  Vue.use(Fragment.Plugin)
}

export function registerFilters() {
  Vue.filter('kilometers', toKilometers)
  Vue.filter('date', toDate)
}

export function registerMixins() {
  Vue.mixin(alertModalMixin)
}
